// REDUX ACTION TYPES
export default {
  // auth
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  UPDATE_MERCHANT: 'UPDATE_MERCHANT'
};
